export default __webpack_public_path__ + "error.d1b56621.svg";